/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Basic_Dry_Buzzard_CheerInputs */

const fr_basic_dry_buzzard_cheer = /** @type {(inputs: Basic_Dry_Buzzard_CheerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste des cours`)
};

/**

* @param {Basic_Dry_Buzzard_CheerInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const basic_dry_buzzard_cheer = /** @type {((inputs?: Basic_Dry_Buzzard_CheerInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Basic_Dry_Buzzard_CheerInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_basic_dry_buzzard_cheer(inputs)
});